module.exports = __webpack_public_path__ + "public/img/maintenance.bdd8e4eb.png";